import React from "react";
import "./mobileList.css";

import MenuItem from "../../../commonComponents/MenuItem/MenuItem";

export default function MobileList({ menuItems }) {
  return (
    <div className="mobile-product-list">
      {menuItems.map((val) => (
        <MenuItem key={val.ProductId} data={val} />
      ))}
    </div>
  );
}
